import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import { autobind } from 'core-decorators';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { FlexRowContainer } from 'components/StyledComp';
import Header from 'components-desktop/Header';
import Footer from 'components-desktop/Footer';
import Sidebar from 'components-desktop/Sidebar';

// Login pages.
import LoginPage from 'pages-desktop/login/LoginPage';

// Patient pages.
import AddNewPatientPage from 'pages-desktop/patients/AddNewPatientPage';
import PatientProfilePage from 'pages-desktop/patients/PatientProfilePage';
import PatientsPage from 'pages-desktop/patients/PatientsPage';
import SearchPatientsPage from 'pages-desktop/patients/SearchPatientsPage';
import SearchPatientsVcsPage from 'pages-desktop/patients/SearchPatientsVcsPage';

// Caregiver pages.
import AddNewCaregiverPage from 'pages-desktop/caregivers/AddNewCaregiverPage';
import CaregiverProfilePage from 'pages-desktop/caregivers/CaregiverProfilePage';
import CaregiversPage from 'pages-desktop/caregivers/CaregiversPage';
import SearchCaregiversPage from 'pages-desktop/caregivers/SearchCaregiversPage';
import SearchNewCaregiversPage from 'pages-desktop/caregivers/SearchNewCaregiversPage';
import SearchExpireCaregiversPage from 'pages-desktop/caregivers/SearchExpireCaregiversPage';
import SearchCaregiverSickLeavesPage from 'pages-desktop/caregivers/SearchCaregiverSickLeavesPage';
import SearchEfilesPage from 'pages-desktop/caregivers/SearchEfilesPage';

// Visits pages.
import SearchVisitsPage from 'pages-desktop/visits/SearchVisitsPage';
import SearchUnbillableVisitsPage from 'pages-desktop/visits/SearchUnbillableVisitsPage';
import ConfirmVisitsPage from 'pages-desktop/visits/ConfirmVisitsPage';

// Evv pages.
import SearchEvvsPage from 'pages-desktop/evv/SearchEvvsPage';
import ExportDutySheetPage from 'pages-desktop/evv/ExportDutySheetPage';

// Invoices pages.
import CreateInvoicesPage from 'pages-desktop/invoices/CreateInvoicesPage';
import CreateAdminFeeInvoicesPage from 'pages-desktop/invoices/CreateAdminFeeInvoicesPage';
import SearchInvoicesPage from 'pages-desktop/invoices/SearchInvoicesPage';
import CreateEbillingsPage from 'pages-desktop/invoices/CreateEbillingsPage';
import InvoiceDetailsPage from 'pages-desktop/invoices/InvoiceDetailsPage';

// Payments pages.
import AddPaymentPage from 'pages-desktop/payments/AddPaymentPage';
import SearchPaymentsPage from 'pages-desktop/payments/SearchPaymentsPage';
import PaymentDetailsPage from 'pages-desktop/payments/PaymentDetailsPage';
import UploadEraPage from 'pages-desktop/payments/UploadEraPage';

// Reports pages.
import CaregiverPayrollsPage from 'pages-desktop/reports/CaregiverPayrollsPage';
import AccountReceivablePage from 'pages-desktop/reports/AccountReceivablePage';
// import AccountReceivableLessPage from 'pages-desktop/reports/AccountReceivableLessPage';
import SearchExpiringAuthsPage from 'pages-desktop/reports/SearchExpiringAuthsPage';
import SearchActiveMasterweeksPage from 'pages-desktop/reports/SearchActiveMasterweeksPage';

// Providers pages.
import CareBridgeVisitsPage from 'pages-desktop/providers/CareBridgeVisitsPage';
import HhaExchangeVisitsPage from 'pages-desktop/providers/HhaExchangeVisitsPage';
import EMedNyVisitsPage from 'pages-desktop/providers/EMedNyVisitsPage';

// Companies pages.
import SearchServicesPage from 'pages-desktop/companies/SearchServicesPage';

// Settings pages.
import ChangePasswordPage from 'pages-desktop/settings/ChangePasswordPage';

const AppRoot = styled.div`
`;

const MainRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const embedRouterData = (Component) => (<Component location={location} navigate={navigate} />);

  return (
    <Routes>
      <Route path="/" element={embedRouterData(PatientsPage)} />
      <Route path="/login" element={embedRouterData(LoginPage)} />
      <Route path="/patients/add_patient" element={embedRouterData(AddNewPatientPage)} />
      <Route path="/patients/patient_profile" element={embedRouterData(PatientProfilePage)} />
      <Route path="/patients/patients" element={embedRouterData(PatientsPage)} />
      <Route path="/patients/search_patients" element={embedRouterData(SearchPatientsPage)} />
      <Route path="/patients/search_patients_vcs" element={embedRouterData(SearchPatientsVcsPage)} />
      <Route path="/caregivers/add_caregiver" element={embedRouterData(AddNewCaregiverPage)} />
      <Route path="/caregivers/caregiver_profile" element={embedRouterData(CaregiverProfilePage)} />
      <Route path="/caregivers/caregivers" element={embedRouterData(CaregiversPage)} />
      <Route path="/caregivers/search_caregivers" element={embedRouterData(SearchCaregiversPage)} />
      <Route path="/caregivers/search_new_caregivers" element={embedRouterData(SearchNewCaregiversPage)} />
      <Route path="/caregivers/search_expire_caregivers" element={embedRouterData(SearchExpireCaregiversPage)} />
      <Route path="/caregivers/caregiver_sick_leave_report" element={embedRouterData(SearchCaregiverSickLeavesPage)} />
      <Route path="/caregivers/search_efiles" element={embedRouterData(SearchEfilesPage)} />
      <Route path="/visits/search_visits" element={embedRouterData(SearchVisitsPage)} />
      <Route path="/visits/search_unbillable_visits" element={embedRouterData(SearchUnbillableVisitsPage)} />
      <Route path="/visits/confirm_visits" element={embedRouterData(ConfirmVisitsPage)} />
      <Route path="/evv/search_evvs" element={embedRouterData(SearchEvvsPage)} />
      <Route path="/evv/export_duty_sheet" element={embedRouterData(ExportDutySheetPage)} />
      <Route path="/invoices/create_invoices" element={embedRouterData(CreateInvoicesPage)} />
      <Route path="/invoices/create_admin_fee_invoices" element={embedRouterData(CreateAdminFeeInvoicesPage)} />
      <Route path="/invoices/search_invoices" element={embedRouterData(SearchInvoicesPage)} />
      <Route path="/invoices/create_ebillings" element={embedRouterData(CreateEbillingsPage)} />
      <Route path="/invoices/invoice_details" element={embedRouterData(InvoiceDetailsPage)} />
      <Route path="/invoices/account_receivable" element={embedRouterData(AccountReceivablePage)} />
      <Route path="/payments/add_payment" element={embedRouterData(AddPaymentPage)} />
      <Route path="/payments/search_payments" element={embedRouterData(SearchPaymentsPage)} />
      <Route path="/payments/payment_details" element={embedRouterData(PaymentDetailsPage)} />
      <Route path="/payments/upload_era" element={embedRouterData(UploadEraPage)} />
      <Route path="/reports/caregiver_payrolls" element={embedRouterData(CaregiverPayrollsPage)} />
      {/* <Route path="/reports/account_receivable"
      element={embedRouterData(AccountReceivableLessPage)} /> */}
      <Route path="/reports/account_receivable" element={embedRouterData(AccountReceivablePage)} />
      <Route path="/reports/search_expiring_auths" element={embedRouterData(SearchExpiringAuthsPage)} />
      <Route path="/reports/search_active_masterweeks" element={embedRouterData(SearchActiveMasterweeksPage)} />
      <Route path="/providers/care_bridge_visits" element={embedRouterData(CareBridgeVisitsPage)} />
      <Route path="/providers/hha_exchange_visits" element={embedRouterData(HhaExchangeVisitsPage)} />
      <Route path="/providers/emedny_visits" element={embedRouterData(EMedNyVisitsPage)} />
      <Route path="/companies/search_services" element={embedRouterData(SearchServicesPage)} />
      <Route path="/settings/change_password" element={embedRouterData(ChangePasswordPage)} />
    </Routes>
  );
};

@autobind
class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { Header: AntdHeader, Footer: AntdFooter, Content: AntdContent, Sider } = Layout;

    return (
      <AppRoot>
        {location.pathname.startsWith('/login') &&
          <FlexRowContainer
            width="match_parent"
            height="wrap_content"
            minHeight="100vh"
            alignItems="stretch"
          >
            <MainRoutes />
          </FlexRowContainer>
        }

        {!location.pathname.startsWith('/login') &&
          <Layout>
            <Sider
              width={256}
              breakpoint="lg"
              collapsedWidth="0"
              collapsible
            >
              <Sidebar
                width="match_parent"
                height="wrap_content"
              />
            </Sider>

            <Layout
              style={{ minHeight: '100vh' }}
            >
              <AntdHeader
                style={{ background: '#001529' }}
              >
                <Header
                  width="match_parent"
                  height="match_parent"
                />
              </AntdHeader>

              <AntdContent
                style={{
                  padding: '24px 28px 0 28px',
                  background: '#ffffff',
                }}
              >
                <MainRoutes />
              </AntdContent>

              <AntdFooter
                style={{ background: '#001529' }}
              >
                <Footer
                  width="match_parent"
                  height="wrap_content"
                />
              </AntdFooter>
            </Layout>
          </Layout>
        }
      </AppRoot>
    );
  }
}

export default App;
